<template>
	<!-- 英语页面 -->
	<div class="container homepage">
		<Header/>
		<div class="header_title">
			<div class="header_content">
				<div class="left">
					<div class="Edition_top">
						<div class="Edition_left">
							<span class="span1">{{baseInfoData.title}}</span>
							<span class="span2">已练习课程数：{{baseInfoData.courseFinishNum}}/{{baseInfoData.courseTotalNum}}</span>
						</div>
						<div class="Edition_right">
							<span @click="openBookModal" class="span3">切换课本</span>
						</div>
					</div>
				</div>
				<div class="right">
					<div class="Calculation">
						<div class="nav statistics">
							<span class="number">{{ baseInfoData.correct }}%</span>
							<span class="title">正确率</span>
						</div>
						<div class="nav2 statistics">
							<span class="number">{{ baseInfoData.challengeTimes }}</span>
							<span class="title">累计训练次数</span>
						</div>
						<div class="nav3 statistics">
							<span class="number">{{ baseInfoData.challengeLengthOfTime }}</span>
							<span class="title">累计训练时长</span>
						</div>
						<div class="nav4 statistics">
							<span class="number">{{ baseInfoData.avgChallengeLengthOfTime }}</span>
							<span class="title">平均训练时长</span>
						</div>
					</div>
					<div class="Progress">
						<div class="Edition_bottom">
                            <span class="school">
                                <img v-if="baseInfoData.levelImgData && baseInfoData.levelImgData.length > 0 && baseInfoData.levelImgData[0].imgUrl" class="icon12" :src="baseInfoData.levelImgData[0].imgUrl"/>
                                <span>{{baseInfoData.targetTaskNum && baseInfoData.targetTaskNum[0]}}</span>
                            </span>
							<span class="school">
                                <img v-if="baseInfoData.levelImgData && baseInfoData.levelImgData.length > 1 && baseInfoData.levelImgData[1].imgUrl" class="icon12" :src="baseInfoData.levelImgData && baseInfoData.levelImgData[1].imgUrl"/>
                                <span>{{baseInfoData.targetTaskNum && baseInfoData.targetTaskNum[1]}}</span>
                            </span>
							<span class="school">
                                <img v-if="baseInfoData.levelImgData && baseInfoData.levelImgData.length > 2 && baseInfoData.levelImgData[2].imgUrl" class="icon12" :src="baseInfoData.levelImgData && baseInfoData.levelImgData[2].imgUrl"/>
                                <span>{{baseInfoData.targetTaskNum && baseInfoData.targetTaskNum[2]}}</span>
                            </span>
							<span class="school">
                                <img v-if="baseInfoData.levelImgData && baseInfoData.levelImgData.length > 3 && baseInfoData.levelImgData[3].imgUrl" class="icon12" :src="baseInfoData.levelImgData && baseInfoData.levelImgData[3].imgUrl"/>
                                <span>{{baseInfoData.targetTaskNum && baseInfoData.targetTaskNum[3]}}</span>
                            </span>
							<span class="school">
                                <img v-if="baseInfoData.levelImgData && baseInfoData.levelImgData.length > 4 && baseInfoData.levelImgData[4].imgUrl" class="icon12" :src="baseInfoData.levelImgData && baseInfoData.levelImgData[4].imgUrl"/>
                                <span>{{baseInfoData.targetTaskNum && baseInfoData.targetTaskNum[4]}}</span>
                            </span>
							<span class="school">
                                <img v-if="baseInfoData.levelImgData && baseInfoData.levelImgData.length > 5 && baseInfoData.levelImgData[5].imgUrl" class="icon12" :src="baseInfoData.levelImgData && baseInfoData.levelImgData[5].imgUrl"/>
                                <span>{{baseInfoData.targetTaskNum && baseInfoData.targetTaskNum[5]}}</span>
                            </span>
							<span class="school">
                                <img v-if="baseInfoData.levelImgData && baseInfoData.levelImgData.length > 6 && baseInfoData.levelImgData[6].imgUrl" class="icon12" :src="baseInfoData.levelImgData && baseInfoData.levelImgData[6].imgUrl"/>
                                <span>{{baseInfoData.targetTaskNum && baseInfoData.targetTaskNum[6]}}</span>
                            </span>
							<span class="school">
                                <img v-if="baseInfoData.levelImgData && baseInfoData.levelImgData.length > 7 && baseInfoData.levelImgData[7].imgUrl" class="icon12" :src="baseInfoData.levelImgData && baseInfoData.levelImgData[7].imgUrl"/>
                                <span>{{baseInfoData.targetTaskNum && baseInfoData.targetTaskNum[7]}}</span>
                            </span>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="content">
			<!-- 左边内容部分 -->
			<div class="left">
				<div class="scroll_div">
					<!-- 这里的标签名称要和main.js文件中定义的组件名称保持一致 -->
					<happy-scroll size="8" color="#DDDDDD" resize left hide-horizontal>
						<!-- 内层盒子——内容区 -->
						<div class="con">
							<div class="Article_title" v-for="(item,index) in capterList" :key="index">
								<p class="menu"><a :href="'#c'+item.capterNum">{{item.capterNum}} {{ item.capterName }}</a></p>
								<div v-for="(item2,i) in item.sections" :key="i">
									<p class="menu2"><a :href="'#s'+item2.sectionNum">{{item2.sectionNum}} {{ item2.sectionName }}</a></p>
								</div>
							</div>
						</div>
					</happy-scroll>
				</div>
			</div>
			<div class="right">
				<div v-for="item in capterRightList" :key="item.id">
					<div class="title">
						<span class="serial_number" style="width: 12%" :id="'c'+item.capterNum">{{ item.capterNum }}</span>
						<span class="subtitle" style="width: 32%">{{ item.capterName }}</span>
						<span class="ctgg" @click="ctggFN(item.capterId)">错题巩固</span>
					</div>
					<div class="sub-content" v-for="content in item.sections" :key="content.id">
						<div class="left_content">
                            <span class="left_one" v-if="content.sectionName == '词汇积累' && content.times != 0">
                                <img class="icon11" src="../../src/assets/images/challenge_en_default_img.png"/>
                            </span>
							<span class="left_one" v-if="content.sectionName != '词汇积累' || content.times == 0 ">
                                <img class="icon11" :src="computerImg(content.levelImgData, content.highestLevel, content.highestLevelImgUrl)"/>
                            </span>
							<span class="left_two" :id="'s'+content.sectionNum">{{content.sectionNum}} {{content.sectionName }}</span>
						</div>
						<div class="right_content" v-if="content.sectionName == '词汇积累' ">
							<div class="times">
								<div class="sorts">
									<span class="time">{{ content.times }}</span>
									<span class="name">累计训练次数</span>
								</div>
								<div class="sorts">
									<span class="time">{{ content.longOfTime }}</span>
									<span class="name">累计训练时长</span>
								</div>
								<div class="sorts">
									<span class="time">{{ content.avgLongOfTime }}</span>
									<span class="name">平均训练时长</span>
								</div>
								<div class="sorts">
                                    <span class="time">
                                        <i class="iconfont icon-shijian"></i>
                                    </span>
									<span class="name">{{content.lastChallengeTime}}</span>
								</div>
								<div class="sorts">
                                    <span @click="viewData(content.sectionId,content.sectionName,content.sectionNum)"
										  class="time">
                                        <i class="iconfont icon-tongji"></i>
                                    </span>
									<span class="name" @click="viewData(content.sectionId,content.sectionName,content.sectionNum)"
										  style="cursor: pointer;">查看统计</span>
								</div>
								<div class="small" style="display: grid;width: 263px;position: inherit;justify-content: right;margin-top: -20px;">
									<div class="Challenge"
										 @click="handleToChallenge(content.sectionId,content.sectionName,content.sectionNum,1)"
										 v-if="Number(content.isOpen) === 1"
										 :class="content.isOpen == 1 ? 'no_locked' : 'locked'">
										{{"单词默写"}}
									</div>
									<div class="Challenge"
										 @click="handleToChallenge(content.sectionId,content.sectionName,content.sectionNum,2)"
										 v-if="Number(content.isOpen) === 1"
										 :class="content.isOpen == 1 ? 'no_locked' : 'locked'">
										{{"短语默写"}}
									</div>
									<div class="Challenge"
										 @click="handleToChallenge(content.sectionId,content.sectionName,content.sectionNum,3)"
										 v-if="Number(content.isOpen) === 1"
										 :class="content.isOpen == 1 ? 'no_locked' : 'locked'">
										{{"句子默写"}}
									</div>
								</div>
							</div>
						</div>
						<div class="right_content" v-if="content.sectionName != '词汇积累' ">
							<div class="times">
								<div class="sorts">
									<span class="time">{{ content.times }}</span>
									<span class="name">累计训练次数</span>
								</div>
								<div class="sorts">
									<span class="time">{{ content.longOfTime }}</span>
									<span class="name">累计训练时长</span>
								</div>
								<div class="sorts">
									<span class="time">{{ content.avgLongOfTime }}</span>
									<span class="name">平均训练时长</span>
								</div>
								<div class="sorts">
                                    <span class="time">
                                        <i class="iconfont icon-shijian"></i>
                                    </span>
									<span class="name">{{content.lastChallengeTime}}</span>
								</div>
								<div class="sorts">
                                    <span @click="viewData(content.sectionId,content.sectionName,content.sectionNum)"
										  class="time">
                                        <i class="iconfont icon-tongji"></i>
                                    </span>
									<span class="name" @click="viewData(content.sectionId,content.sectionName,content.sectionNum)"
										  style="cursor: pointer;">查看统计</span>
								</div>
								<div class="sorts">
                                    <span class="time">
                                        <i @click="openViewData(content.videoArr,content.sectionName)"
										   class="iconfont icon-bianji"></i>
                                    </span>
									<span class="name" @click="openViewData(content.videoArr,content.sectionName)"
										  style="cursor:pointer;">双师课堂</span>
								</div>
							</div>
							<div class="small">
								<div v-for="(imgItem,index) in content.levelImgData" :key="index">
                                    <span class="img">
                                        <img class="icon12" :class="content.curLevel[index] === 1 ? '' : 'gray'"
											 :src="imgItem.imgUrl"/>
                                    </span>
								</div>
								<div class="Challenge"
									 @click="handleToChallenge(content.sectionId,content.sectionName,content.sectionNum)"
									 v-if="Number(content.isOpen) === 1"
									 :class="content.isOpen == 1 ? 'no_locked' : 'locked'">
									{{"训练"}}
								</div>
								<el-tooltip effect="dark" v-if="Number(content.isOpen) === 0" content="所有前置章节达到清华北大后解锁"
											placement="top">
									<div v-if="Number(content.isOpen) === 1" class="Challenge locked">
										{{"已锁定"}}
									</div>
								</el-tooltip>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer/>
		<div>
			<el-dialog
				title=""
				:visible.sync="ModalBook"
				custom-class="BookModal"
				:before-close="handleClose">
				<div slot="title" class="dialog-title">
					<span>VIP双师课堂</span>
				</div>
				<div class="booklist">
					<div class="book_item" v-for="(item,index) in booklistData" :key="index">
						<div class="book_name">{{item.name}}</div>
						<div v-if="item.coverUrl.indexOf('http')==-1" class="book_img"><img :src="imgHost+item.coverUrl" alt=""></div>
						<div v-if="item.coverUrl.indexOf('http')>-1" class="book_img"><img :src="item.coverUrl" alt=""></div>
						<div class="book_btn" @click="changeBook(item.id,item.useFlag)"
							 :class="item.useFlag == '1' ? 'current_book' : 'other_book'">{{item.useFlag != 1 ? "使用教材" :
							"使用中"}}
						</div>
					</div>
				</div>
				<div class="nodata" v-if="booklistData.length <= 0">
					<div>无教材数据，请联系学管师添加！</div>
				</div>
			</el-dialog>
		</div>
		<div>
			<el-dialog
				:visible.sync="dialogTableVisible"
				:modal="false"
				@close="closeVideoModal"
				top="20vh"
				width="752px"
				:destroy-on-close="true"
				custom-class="videoModal"
			>
				<div slot="title" class="dialog-title">
					<span>VIP双师课堂</span>
				</div>
				<div class="dialog-content" :modal-append-to-body="false" v-if="videoArr.length > 0">
					<div class="dialog-left" style="overflow-y: auto;height: 361px;">
						<div class="arr" v-for="(videoItem, i) in videoArr" :key="i">
							<span class="circular"></span>
							<div class="left-title" @click="changeCurrentVideoItem(videoItem)">
								{{videoItem.name}}
							</div>
						</div>
					</div>
					<div class="dialog-right">
						<div class="watch">
							<div class="video-container">
								<video
									ref="videoPlayer"
									:src="currentVideoUrl"
									controls="controls"
									controlslist="nodownload noremoteplayback nofullscreen"
									:disablePictureInPicture="true"
									autoplay="autoplay"
									width="100%"
									height="100%"
									oncontextmenu="return false"
									@play="startWatermark"
									@pause="stopWatermark"
									@seeked="updateWatermark"
								></video>
								<canvas ref="watermarkCanvas" class="watermark-layer"></canvas>
								<div ref="fullscreenBtn" class="custom-fullscreen-btn" @click="toggleContainerFullscreen">
									<i class="iconfont icon-fullscreen"></i>
								</div>
							</div>
						</div>
						<div class="video_operation">
							<div
								:class="currentVideoIndex === i ? 'selected-div' : 'default-div'"
								v-for="(item, i) in currentVideoItem.video"
								:key="i"
								@click="changeVideoUrl(i, item.videoUrl)"
							>
								{{item.name}}
							</div>
						</div>
					</div>
				</div>
				<div v-else class="dialog-nodata">
					<span>暂无视频信息</span>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import Header from "../components/common/Header";
	import Footer from "../components/common/Footer";
	import api from "../axios/interface";

	export default {
		name: "SubjectHome",
		data() {
			return {
				dialogTableVisible: false,
				dialogFormVisible: false,
				booklistData: [],
				imgHost: api.HostUrl,
				subjectId: this.$route.query.subjectId,
				ModalBook: false, // 切换课本弹窗
				baseInfoData: {},
				statisticsData: [],
				capterList: [],
				num: 0,
				capterRightList: [],
				videoArr: [],
				currentVideoItem: {},
				currentVideoIndex: 0,
				currentSectionName: "",
				currentVideoUrl: "",
				watermarkInterval: null,
				isFullscreenEventBound: false, // 新增：标记全屏事件是否已绑定
				resizeRetryCount: 0, // 保留：尺寸重试计数
				studentInfo: {
					name: "张三",
					id: "S2023001",
					class: "高三(5)班"
				}
			};
		},
		mounted() {
			this.initSubjectCapterChallengeList()
			this.initSubjectCapterList()
			this.initSubjectBaseinfo()
		},
		computed: {},
		methods: {
			initSubjectCapterList() {
				this.$axios.get(api.SUBJECTCAPTERLIST, {subjectId: this.subjectId}, {hideMessage: true})
					.then(res => {
						this.capterList = res.result.data;
					})
					.catch(res => {
					});
			},
			initSubjectCapterChallengeList() {
				this.$axios.get(api.SUBJECTCAPTERHALLENGELIST, {subjectId: this.subjectId}, {hideMessage: true})
					.then(res => {
						this.capterRightList = (res.result == null ? [] :res.result.data);
						if(this.capterRightList == null || this.capterRightList.length <= 0){
							this.openBookModal();
						}
					})
					.catch(res => {
					});
			},
			initSubjectBaseinfo() {
				this.$axios.get(api.SUBJECTBASEINFO, {subjectId: this.subjectId}, {hideMessage: true})
					.then(res => {
						res.result.targetTaskNum = res.result.targetTaskNum.split(",");
						this.baseInfoData = res.result;
						this.num = Number(res.result.courseFinishNum) / Number(res.result.courseTotalNum) * 100;
					})
					.catch(res => {
					});
			},

			// 获取科目章节列表
			getSubjectBookList() {
				this.$axios.get(api.SUBJECTBOOKLIST, {subjectId: this.subjectId}, {loading: false,hideMessage: true})
					.then(res => {
						this.booklistData = res.result.data;
					})
					.catch(res => {
					});
			},

			// 跳转做题挑战页
			handleToChallenge(sectionId, sectionName, num, enType) {
				// type 1 为科目主页的挑战； type: 2 为我的任务挑战
				let rName = sectionName == '词汇积累' ? 'enchallenge' : 'challenge'
				if (!enType) {
					enType = 0
				}
				this.$router.push({
					name: rName,
					query: {type: 1, sectionId: sectionId, subjectId: this.subjectId, name: num + sectionName, enType: enType, ran: Math.random()}
				});
			},
			// 使用课本/切换课本
			changeBook(bookid, useflag) {
				let that = this;
				if (Number(useflag)) {
					that.$message({
						showClose: true,
						message: "课本已经在使用中",
						duration: 1000,
						type: "info"
					});
					return false;
				}
				this.$axios.get(api.SUBJECTBOOKCHANGE, {id: bookid}, {hideMessage: true})
					.then(res => {
						that.ModalBook = false;
						that.$message({
							showClose: true,
							message: "切换课本成功",
							duration: 1000,
							type: "success"
						});
						this.initSubjectCapterList();
						this.initSubjectCapterChallengeList();
						this.initSubjectBaseinfo();
						this.getSubjectBookList();
					})
					.catch(res => {
					});
			},

			openBookModal() {
				this.getSubjectBookList();
				this.ModalBook = true;
			},

			handleClose() {
				this.ModalBook = false;
			},
			// 新增：切换容器全屏状态
			toggleContainerFullscreen() {
				const videoContainer = this.$refs.videoPlayer?.parentElement;
				if (!videoContainer) return;

				// 关键修复：兼容所有浏览器的全屏状态判断
				const isFullscreen =
					document.fullscreenElement ||
					document.webkitFullscreenElement ||
					document.mozFullScreenElement ||
					document.msFullscreenElement; // 补充 IE/Edge 兼容（可选）

				// 关键修复：兼容所有浏览器的退出全屏方法
				const exitFullscreen =
					document.exitFullscreen ||
					document.webkitExitFullscreen ||
					document.mozCancelFullScreen ||
					document.msExitFullscreen; // 补充 IE/Edge 兼容

				// 关键修复：兼容所有浏览器的进入全屏方法
				const requestFullscreen =
					videoContainer.requestFullscreen ||
					videoContainer.webkitRequestFullscreen ||
					videoContainer.mozRequestFullScreen ||
					videoContainer.msRequestFullscreen; // 补充 IE/Edge 兼容

				if (isFullscreen) {
					// 退出全屏：确保图标同步切换
					exitFullscreen.call(document).then(() => {
						this.$refs.fullscreenBtn?.classList.remove('exit'); // 移除「退出」图标类
					}).catch(err => {
						console.warn('退出全屏失败:', err);
						// 异常情况下强制切换图标，避免状态不一致
						this.$refs.fullscreenBtn?.classList.remove('exit');
					});
				} else {
					// 进入全屏：确保图标同步切换
					requestFullscreen.call(videoContainer).then(() => {
						this.$refs.fullscreenBtn?.classList.add('exit'); // 添加「退出」图标类
					}).catch(err => {
						console.warn('容器全屏失败:', err);
						// 异常情况下强制切换图标
						this.$refs.fullscreenBtn?.classList.add('exit');
					});
				}
			},

			// 移除原有的视频全屏拦截逻辑（无需再监听视频全屏事件）
			initWatermark() {
				const video = this.$refs.videoPlayer;
				const canvas = this.$refs.watermarkCanvas;
				const videoContainer = video?.parentElement;
				const fullscreenBtn = this.$refs.fullscreenBtn; // 获取按钮引用

				if (!video || !canvas || !videoContainer || !fullscreenBtn) return;

				this.resizeCanvas();

				// 原有全屏状态同步逻辑 + 新增图标同步
				const handleContainerFullscreenChange = () => {
					const isContainerFullscreen =
						document.fullscreenElement === videoContainer ||
						document.webkitFullscreenElement === videoContainer ||
						document.mozFullScreenElement === videoContainer;

					// 原有水印尺寸同步逻辑（保留）
					if (isContainerFullscreen) {
						canvas.style.position = 'fixed';
						canvas.style.width = '100vw';
						canvas.style.height = '100vh';
						canvas.style.zIndex = '2147483647';
					} else {
						canvas.style.position = 'absolute';
						canvas.style.width = '100%';
						canvas.style.height = '100%';
						canvas.style.zIndex = '9999';
					}
					this.resizeCanvas();

					// 关键新增：根据全屏状态同步按钮图标
					if (isContainerFullscreen) {
						fullscreenBtn.classList.add('exit'); // 全屏时显示「退出」图标
					} else {
						fullscreenBtn.classList.remove('exit'); // 非全屏时显示「进入」图标
					}
				};

				// 绑定全屏事件（保留原有）
				document.addEventListener('fullscreenchange', handleContainerFullscreenChange);
				document.addEventListener('webkitfullscreenchange', handleContainerFullscreenChange);
				document.addEventListener('mozfullscreenchange', handleContainerFullscreenChange);
				document.addEventListener('MSFullscreenChange', handleContainerFullscreenChange); // 补充 IE/Edge 兼容

				// 组件销毁时移除监听（保留原有，补充新添加的事件）
				this.$once('hook:beforeDestroy', () => {
					document.removeEventListener('fullscreenchange', handleContainerFullscreenChange);
					document.removeEventListener('webkitfullscreenchange', handleContainerFullscreenChange);
					document.removeEventListener('mozfullscreenchange', handleContainerFullscreenChange);
					document.removeEventListener('MSFullscreenChange', handleContainerFullscreenChange); // 补充移除

					// 原有其他事件移除（保留）
					video.removeEventListener('play', this.startWatermark);
					video.removeEventListener('pause', this.stopWatermark);
					video.removeEventListener('seeked', this.drawWatermark);
					video.removeEventListener('resize', this.resizeCanvas);
				});

				// 原有视频事件监听（保留，注意避免重复绑定）
				if (!this.isFullscreenEventBound) {
					video.addEventListener('play', this.startWatermark);
					video.addEventListener('pause', this.stopWatermark);
					video.addEventListener('seeked', this.drawWatermark);
					video.addEventListener('resize', this.resizeCanvas);
					this.isFullscreenEventBound = true;
				}
			},
			resizeCanvas() {
				const video = this.$refs.videoPlayer;
				const canvas = this.$refs.watermarkCanvas;
				const videoContainer = video.parentElement;

				if (!video || !canvas) return;

				// 新增：延迟重试逻辑，解决尺寸同步滞后问题
				const syncSize = () => {
					let containerWidth = videoContainer.offsetWidth;
					let containerHeight = videoContainer.offsetHeight;

					// 若容器尺寸未获取到，重试（最多3次）
					if ((containerWidth === 0 || containerHeight === 0) && this.resizeRetryCount < 3) {
						this.resizeRetryCount = (this.resizeRetryCount || 0) + 1;
						setTimeout(syncSize, 100); // 100ms后重试
						return;
					}

					this.resizeRetryCount = 0; // 重置重试计数

					if (containerWidth === 0 || containerHeight === 0) {
						containerWidth = video.videoWidth || 640;
						containerHeight = video.videoHeight || 360;
					}

					const isFullscreen = document.fullscreenElement || document.webkitFullscreenElement;
					if (isFullscreen && (isFullscreen === video || isFullscreen === videoContainer)) {
						containerWidth = window.innerWidth;
						containerHeight = window.innerHeight;
					}

					// 强制更新Canvas尺寸（关键修复：避免尺寸未实际更新）
					canvas.width = containerWidth;
					canvas.height = containerHeight;
					canvas.style.width = `${containerWidth}px`;
					canvas.style.height = `${containerHeight}px`;

					this.drawWatermark();
				};

				syncSize(); // 执行尺寸同步
			},
			// 开始绘制水印
			startWatermark() {
				this.drawWatermark();
				if (this.watermarkInterval) {
					clearInterval(this.watermarkInterval);
				}
				this.watermarkInterval = setInterval(this.drawWatermark, 1000);
			},

			// 停止绘制水印
			stopWatermark() {
				if (this.watermarkInterval) {
					clearInterval(this.watermarkInterval);
					this.watermarkInterval = null;
				}
			},

			// 更新水印
			updateWatermark() {
				this.drawWatermark();
			},

			// 绘制水印
			drawWatermark() {
				let canvas = this.$refs.watermarkCanvas;
				const video = this.$refs.videoPlayer;
				const videoContainer = video?.parentElement;

				// 双重校验：若Canvas不存在或已脱离DOM，重新创建
				if (!canvas || !canvas.parentElement || canvas.parentElement !== videoContainer) {
					// 移除旧Canvas（若存在）
					if (canvas) canvas.remove();
					// 重新创建Canvas
					canvas = document.createElement('canvas');
					canvas.className = 'watermark-layer';
					videoContainer.appendChild(canvas);
					this.$refs.watermarkCanvas = canvas; // 更新ref引用
				}

				if (!video || !canvas || video.paused || video.ended) return;

				const ctx = canvas.getContext('2d');
				ctx.clearRect(0, 0, canvas.width, canvas.height);

				// 绘制半透明背景水印
				ctx.font = "bold 24px Arial";
				ctx.fillStyle = "rgba(255, 255, 255, 0.1)";
				ctx.textAlign = "center";
				ctx.textBaseline = "middle";

				// 平铺水印文本
				for (let x = 50; x < canvas.width; x += 200) {
					for (let y = 50; y < canvas.height; y += 100) {
						ctx.save();
						ctx.translate(x, y);
						ctx.rotate(-Math.PI / 6);
						ctx.fillText(`www.vipss.vip`, 0, 0);
						// ctx.fillText(`双师课堂 ${this.studentInfo.name} ${this.studentInfo.id}`, 0, 0);
						ctx.restore();
					}
				}

				// 绘制右下角动态时间水印
				const now = new Date();
				const timeStr = now.toLocaleString('zh-CN');
				ctx.font = "16px Arial";
				ctx.fillStyle = "rgba(255, 255, 255, 0.7)";
				ctx.textAlign = "right";
				ctx.textBaseline = "bottom";
				ctx.fillText(`时间: ${timeStr}`, canvas.width - 10, canvas.height - 10);
			},
			closeVideoModal() {
				this.dialogTableVisible = false;
				this.currentVideoUrl = "";
				this.currentVideoItem = {};
				this.stopWatermark();
			},

			openViewData(val, name) {
				this.dialogTableVisible = true;
				this.videoArr = val;
				this.currentSectionName = name;

				if (val.length > 0) {
					this.currentVideoItem = val[0];
					if (val[0].video) {
						this.changeVideoUrl(0, val[0].video[0].videoUrl);
					}
					// 关键修改：延长等待时间至500ms，确保视频元素渲染完成
					this.$nextTick(() => {
						setTimeout(() => {
							this.initWatermark(); // 初始化水印（此时事件未绑定，会执行）
						}, 500);
					});
				}
			},

			// 切换左侧菜单：移除水印初始化，仅重置绘制
			changeCurrentVideoItem(videoItem) {
				this.currentVideoItem = videoItem;
				if (videoItem.video && videoItem.video.length > 0) {
					this.currentVideoUrl = videoItem.video[0].videoUrl;
				}
				this.$nextTick(() => {
					this.stopWatermark(); // 停止旧水印
					setTimeout(() => {
						this.startWatermark(); // 启动新水印（无需重新init）
						this.resizeCanvas(); // 同步新视频尺寸
					}, 300);
				});
			},

// 切换视频：同样移除水印初始化
			changeVideoUrl(index, url) {
				this.currentVideoIndex = index;
				this.currentVideoUrl = url;
				this.$nextTick(() => {
					this.stopWatermark();
					setTimeout(() => {
						this.startWatermark();
						this.resizeCanvas();
					}, 300);
				});
			},

			click() {
				//定义定时器开始时间为0
				var progressnuw = 0; //顶一个定时器
				var timer = setInterval(() => {
					//变量一直++
					progressnuw++; //清楚定时器
					if (progressnuw >= 100) {
						clearInterval(timer);
					} //获取重新赋值
					this.nuw = progressnuw;
				}, 30);
			},
			viewData(sectionId, sectionName, sectionNum) {
				this.$router.push({
					name: sectionName == '词汇积累' ? "ViewEnStatistics" : "ViewStatistics",
					query: {id: sectionId, name: sectionNum + sectionName}
				});
			},
			ctggFN(id){
				let that = this;
				this.$axios.get(
					api.ExamQuestionListCapter,
					{ textbookCapterId: id },
					{ hideMessage: true }
				).then(res => {
					if (res.result == null) {
						that.$message({
							showClose: true,
							message: "未发现错题",
							duration: 2500,
							type: "warning"
						});
					} else {
						that.$router.push({
							path: "/errorContentCapter", //跳转路由
							query: {
								textbookCapterId: id
							}
						});
					}
				}).catch( res => {});
			},
			computerImg(levelImgData, highestLevel, highestLevelImgUrl) {
				let imgUrl = "";
				if (highestLevelImgUrl) {
					imgUrl = highestLevelImgUrl;
					return imgUrl;
				}
				let highestLevelNum = Number(highestLevel);
				let reversedLevelImages = [...levelImgData].reverse();
				if (highestLevelNum === -1) {
					imgUrl = require("../../src/assets/images/level_default.png");
					return imgUrl;
				}
				if (reversedLevelImages[highestLevelNum - 1]) {
					imgUrl = reversedLevelImages[highestLevelNum - 1].imgUrl;
				}
				return imgUrl;
			}
		},
		components: {
			Header: Header,
			Footer: Footer
		}
	};
</script>

<style lang='less'>
	body {
		background-color: #f1f1f1;
	}

	.homepage {
		.icon11 {
			width: 5rem;
			height: 5rem;
		}

		.header_title {
			width: 100%;
			height: 208px;
			background-color: #333;

			.header_content {
				width: 1200px;
				height: 208px;
				margin: 0 auto;
				display: flex;
				flex-direction: row;
				position: relative;

				.left {
					margin-left: 100px;
					margin-right: 112px;
					display: flex;
					flex-direction: row;
					align-items: center;

					.Edition_top {
						width: 370px;
						height: 62px;
						display: flex;
						flex-direction: row;
						justify-content: flex-start;
						padding-left: 5px;

						.Edition_left {
							max-width: 288px;
							display: flex;
							flex-direction: column;

							.span1 {
								display: inline-block;
								font-size: 20px;
								font-weight: 600;
								color: #fff;
							}

							.span2 {
								display: inline-block;
								font-size: 12px;
								line-height: 24px;
								font-weight: 400;
								color: #999999;
								margin-top: 3px;
							}
						}

						.Edition_right {
							width: 80px;
							height: 24px;

							.span3 {
								cursor: pointer;
								width: 80px;
								height: 24px;
								margin-left: 5px;
								display: inline-block;
								line-height: 24px;
								font-size: 14px;
								color: #fff;
								text-align: center;
								border-radius: 2px;
								background-color: #0079fe;
							}
						}
					}
				}

				.right {
					width: 495px;
					margin-top: 35px;
					text-align: center;
					display: flex;
					flex-direction: column;
					/*justify-content: center;*/

					.Calculation {
						width: 585px;
						display: flex;
						flex-direction: row;
						align-items: center;

						.statistics {
							display: flex;
							flex-direction: column;
							border: 1px solid #999;
							border-radius: 4px;
							margin-left: 24px;
							padding: 8px 0px;
							max-height: 50px;
							// min-width: 90px;
							&:first-of-type {
								margin-left: 0;
							}

							.number {
								color: #fff;
								font-size: 20px;
								line-height: 24px;
							}

							.title {
								color: #999;
								font-size: 12px;
								line-height: 18px;
							}
						}

						.nav, .nav2 {
							min-width: 96px;
						}

						.nav3, .nav4 {
							min-width: 140px;
						}
					}

					.Progress {
						width: 585px;
						display: flex;
						flex-direction: row;
						height: 80px;
						margin-top: 18px;

						.Edition_bottom {
							display: flex;

							.school {
								display: flex;
								flex-direction: column;
								margin-right: 20px;

								img {
									width: 3.2rem;
									height: 3.2rem;
								}

								span {
									color: #999999;
									font-size: 12px;
									line-height: 24px;
									text-align: center;
								}
							}
						}

						.imgs {
							width: 626px;

							.Progress_img {
								width: 56px;
								height: 70px;
							}
						}

						.el-progress-bar {
							.el-progress-bar__outer {
								background-color: #73B5FF;
							}

						}

						.el-progress__text {
							color: #999;
							display: none;
						}
					}
				}
			}
		}

		.header_times {
			width: 1200px;
			height: 60px;
			margin-top: 30px;

			.header_time {
				width: 628px;
				height: 60px;
				display: flex;
				flex-direction: row;
				margin-left: 288px;
			}
		}

		.content {
			width: 1200px;
			height: 100%;
			display: flex;
			flex-direction: row;
			margin-top: 80px;

			.left {
				width: 215px;
				height: 665px;
				margin-left: 50px;
				border-radius: 10px;
				background-color: #ffffff;

				.scroll_div {
					height: 635px;
					padding-top: 15px;
				}

				.con {
					padding: 0 20px;

					.menu {
						font-size: 14px;
						line-height: 22px;
						color: #666666;
						font-weight: 600;
					}

					.menu2 {
						font-size: 12px;
						line-height: 18px;
						color: #999999;
						padding-top: 5px;
						cursor: pointer;
					}

					.menu3 {
						font-size: 12px;
						color: #4d4d4d;
						padding-top: 10px;
					}

					.Article_title {
						padding-bottom: 16px;
					}
				}
			}

			.right {
				display: flex;
				height: auto;
				flex-direction: column;
				padding-right: 20px;
				margin-left: 20px;
				border-radius: 10px;
				margin-right: 50px;
				border: 1px solid #fff;
				background-color: #fff;
				padding-bottom: 80px;

				.title {
					height: 26px;
					display: flex;
					flex-direction: row;
					margin-top: 30px;
					margin-left: 45px;
					padding-bottom: 22px;
					border-bottom: 1px solid #6666;
				}
			}
		}

		.ctgg{
			box-shadow: 0 2px 4px rgba(0,0,0,0.1);
			cursor: pointer;
			color: #fff;
			background-color: #FF6B35;
			width: 88px;
			height: 32px;
			font-size: 14px;
			line-height: 32px;
			text-align: center;
			margin: 10px 0 0 45%;
			border-radius: 5px;
		}
		.serial_number {
			width: 62px;
			height: 26px;
			line-height: 26px;
			border: 1px solid #409aff;
			display: block;
			color: #fff;
			font-size: 18px;
			text-align: center;
			font-weight: 500;
			border-radius: 5px;
			background-color: #0079fe;
		}

		.subtitle {
			width: 300px;
			height: 20px;
			overflow: hidden;
			line-height: 20px;
			padding-left: 10px;
			color: #4d4d4d;
			font-size: 16px;
			margin-top: 4px;
			display: block;
		}

		.sub-content {
			display: flex;
			height: auto;
			flex-direction: row;
			margin-left: 45px;
			margin-top: 20px;
			padding-bottom: 20px;
			border-bottom: 1px solid #6666;

			.left_content {
				width: 230px;
				display: flex;
				align-items: center;
				margin-top: 12px;

				.left_one {
					width: 5rem;
					height: 5rem;
					display: block;
				}

				.left_two {
					padding-left: 10px;
					width: 135px;
					display: block;
					font-size: 16px;
					line-height: 22px;
					color: #333333;
				}
			}

			.right_content {
				display: flex;
				height: auto;
				flex-direction: column;
				margin-left: 5px;

				.times {
					display: flex;
					flex-direction: row;

					.sorts {
						display: flex;
						flex-direction: column;
						width: 95px;

						.img2 {
							width: 23px;
							height: 18px;
						}

						.iconfont {
							&:hover {
								color: #0079fe;
							}
						}

						.time {
							width: 95px;
							height: 28px;
							text-align: center;
							font-size: 20px;
							color: #9b9b9b;
							display: block;
						}

						.name {
							width: 95px;
							font-size: 12px;
							text-align: center;
							color: #9b9b9b;
							line-height: 14px;
							display: block;
						}
					}
				}

				.small {
					display: flex;
					margin-top: 13px;
					height: auto;

					.icon12 {
						width: 4rem;
						height: 4rem;
					}

					.img {
						width: 4rem;
						height: 4rem;
						padding-left: 12px;
					}

					.gray {
						filter: grayscale(100%);
						opacity: 0.5;
					}

					.Challenge {
						width: 88px;
						height: 32px;
						font-size: 14px;
						line-height: 32px;
						text-align: center;
						margin-top: 10px;
						border-radius: 5px;
						margin-left: 40px;
						margin-bottom: 0;
						margin-right: 0;
					}

					.no_locked {
						cursor: pointer;
						color: #fff;
						background-color: #1677FF;
					}

					.locked {
						cursor: pointer;
						width: 88px;
						height: 32px;
						color: #333333;
						background: #FFFFFF;
						border: 1px solid #DDDDDD;
					}
				}
			}
		}

		.videoModal, .BookModal {
			.el-dialog__header {
				background-color: #0079FE;
				height: 56px;
				padding: 0 0 0 24px;

				.dialog-title {
					color: #fff;
					font-size: 16px;
					line-height: 56px;
				}

				.el-dialog__headerbtn .el-dialog__close {
					color: #fff;
				}
			}

			.el-dialog__body {
				padding: 24px;

				.dialog-content {
					display: flex;

					.dialog-left {
						width: 192px;
						margin-right: 10px;

						.arr {
							display: flex;
							padding: 12px 0;
							border-bottom: 1px solid #EEEEEE;

							&:last-of-type {
								border: none;
							}

							.circular {
								display: inline-block;
								height: 12px;
								width: 12px;
								border-radius: 50%;
								margin-right: 10px;
								margin-top: 5px;
								background-color: #0079FE;
							}

							.left-title {
								cursor: pointer;
								font-size: 14px;
								color: #333333;
								line-height: 22px;
								max-width: 135px;
								font-weight: 400;
							}
						}
					}

					.dialog-right {
						.watch {
							width: 536px;
							height: 288px;
							padding: 0;
							border: 1px solid #DDDDDD;

							video {
								height: 100%;
								width: 100%;
							}
						}

						.topic {
							padding: 18px 0;

							.text {
								border-radius: 8px;
								padding: 8px 16px;
								background-color: #F2F2F2;
								color: #9C9C9C;
								font-size: 14px;
								cursor: pointer;
								margin-right: 12px;
							}
							.active_text {
								border-radius: 8px;
								padding: 8px 16px;
								background-color: #1677FF;
								color: #FFFFFF;
								cursor: pointer;
								font-size: 14px;
								margin-right: 12px;
							}
						}
					}
				}

				.dialog-nodata {
					height: 368px;
					display: flex;
					font-size: 23px;
					text-align: center;
					justify-content: center;
					flex-direction: column;
				}
			}

		}

		.BookModal {
			width: 55% !important;
			.booklist {
				display: flex;
				width: 770px;
				max-height: 496px;
				flex-wrap: wrap;
				overflow-y: auto;

				.book_item {
					margin-right: 22px;
					display: flex;
					flex-direction: column;
					align-items: center;
					margin-bottom: 40px;

					&:nth-of-type(5n) {
						margin-right: 0px;
					}

					.book_name {
						width: 100%;
						color: #333333;
						font-size: 14px;
						line-height: 22px;
						text-align: left;
					}

					.book_img {
						margin-top: 18px;
						width: 130px;
						height: 186px;
						box-shadow: 2px 2px 10px #909090;

						img {
							width: 130px;
							height: 186px;
						}
					}

					.book_btn {
						color: #333333;
						width: 88px;
						height: 32px;
						font-size: 14px;
						line-height: 32px;
						text-align: center;
						margin-top: 16px;
						border-radius: 4px;
						cursor: pointer;
					}

					.current_book {
						background-color: #0079FE;
						color: #fff;
					}

					.other_book {
						background-color: #EEEEEE;
						border: 1px solid #DDDDDD;
						color: #333333;
					}
				}
			}

			.nodata {
				display: flex;
				height: 396px;
				font-size: 23px;
				justify-content: center;
				flex-direction: column;
				text-align: center;
				width: 100%;
			}
		}
	}
	.video_operation {
		padding: 18px 0;

		.default-div {
			display: inline-block;
			border-radius: 8px;
			padding: 8px 16px;
			background-color: #F2F2F2;
			cursor: pointer;
			color: #9C9C9C;
			font-size: 14px;
			margin: 0 12px 10px 0;
		}

		.selected-div {
			display: inline-block;
			border-radius: 8px;
			padding: 8px 16px;
			background-color: #1677FF;
			cursor: pointer;
			color: #FFFFFF;
			font-size: 14px;
			margin: 0 12px 10px 0;

		}
	}
	.watch {
		position: relative;
	}

	.video-container {
		position: relative;
		width: 100%;
		height: 100%;
		/* 补充 Firefox 全屏样式 */
		&:fullscreen,
		&:-webkit-full-screen,
		&:-moz-full-screen { /* 新增 Firefox 前缀 */
			width: 100vw !important;
			height: 100vh !important;
			object-fit: contain; /* 保持视频比例，避免拉伸 */
		}
	}
	.custom-fullscreen-btn {
		/* 定位到原全屏按钮位置（右侧，与音量按钮对齐） */
		position: absolute;
		right: 50px;  /* 距离右侧的距离（根据实际控制栏调整） */
		bottom: 30px;  /* 距离底部控制栏的距离 */
		width: 36px;  /* 匹配默认按钮大小 */
		height: 36px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: white;  /* 图标颜色（默认控制栏为白色） */
		background: transparent;  /* 透明背景（默认控制栏样式） */
		cursor: pointer;
		z-index: 999;  /* 确保在视频上方，但不遮挡其他控制元素 */
		font-size: 18px;  /* 图标大小匹配默认样式 */
		opacity: 0.8;  /* 默认半透明，hover 时变亮 */
		/* 新增：防止按钮被视频控件遮挡（部分浏览器控制栏悬浮时层级高） */
		pointer-events: auto !important;
	}

	/* 模拟默认 hover 效果 */
	.custom-fullscreen-btn:hover {
		opacity: 1;
		background: rgba(255, 255, 255, 0.2);  /* 轻微背景色，与默认控制栏一致 */
		border-radius: 4px;  /* 圆角匹配默认按钮 */
	}
	/* 关键修复：全屏状态下的按钮定位 */
	/* 适配 Chrome/Safari */
	.video-container:-webkit-full-screen .custom-fullscreen-btn,
		/* 适配 Firefox */
	.video-container:-moz-full-screen .custom-fullscreen-btn,
		/* 适配标准全屏 */
	.video-container:fullscreen .custom-fullscreen-btn {
		right: 85px; /* 全屏时靠右侧，避免贴近边缘 */
		bottom: 30px; /* 全屏时靠底部，与系统控制栏错开 */
		width: 48px; /* 全屏时放大按钮，提升点击区域 */
		height: 48px;
		font-size: 24px; /* 图标同步放大，视觉更清晰 */
		opacity: 0.9;
		z-index: 2147483647; /* 浏览器最大层级，确保在最顶层 */
	}

	/* 全屏状态切换图标（可选：切换为退出全屏图标） */
	.custom-fullscreen-btn.exit i::before {
		content: "\f066";  /* 替换为退出全屏图标代码（如 FontAwesome 的 fa-compress） */
	}
	/* 补充 Firefox 全屏时 Canvas 样式 */
	.video-container:fullscreen .watermark-layer,
	.video-container:-webkit-full-screen .watermark-layer,
	.video-container:-moz-full-screen .watermark-layer { /* 新增 Firefox 前缀 */
		position: fixed !important;
		width: 100vw !important;
		height: 100vh !important;
		z-index: 2147483647 !important;
	}
	.watermark-layer {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		pointer-events: none;
		z-index: 9999;
		object-fit: cover;
		/* 新增：强制全屏时Canvas跟随容器显示 */
		display: block !important;
	}

	/* 新增：确保视频容器全屏时Canvas也全屏 */
	.video-container:fullscreen .watermark-layer,
	.video-container:-webkit-full-screen .watermark-layer {
		position: fixed !important; /* 脱离文档流，覆盖全屏 */
		width: 100vw !important;
		height: 100vh !important;
		z-index: 2147483647 !important; /* 浏览器最大层级 */
	}

	/* 其他原有样式保持不变 */
	.dialog-title {
		font-size: 16px;
		font-weight: bold;
		color: #303133;
	}

	.dialog-content {
		display: flex;
	}

	.dialog-left {
		width: 240px;
		border-right: 1px solid #ebeef5;
		padding: 10px;
	}

	.dialog-right {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.video_operation {
		display: flex;
		padding: 15px;
		background: #f5f7fa;
		border-top: 1px solid #ebeef5;
	}

	.default-div, .selected-div {
		padding: 8px 15px;
		margin-right: 10px;
		border-radius: 4px;
		cursor: pointer;
		font-size: 14px;
	}

	.default-div {
		background: #fff;
		color: #606266;
		border: 1px solid #dcdfe6;
	}

	.selected-div {
		background: #409eff;
		color: #fff;
		border: 1px solid #409eff;
	}

	.arr {
		display: flex;
		align-items: center;
		padding: 12px 10px;
		border-bottom: 1px solid #ebeef5;
		cursor: pointer;
	}

	.circular {
		width: 8px;
		height: 8px;
		border-radius: 50%;
		background: #c0c4cc;
		margin-right: 10px;
	}

	.left-title {
		font-size: 14px;
		color: #606266;
	}

	.left-title:hover {
		color: #409eff;
	}

	.dialog-nodata {
		text-align: center;
		padding: 40px 0;
		color: #909399;
		font-size: 14px;
	}
</style>
